import React, { Component } from 'react';
import {Grid, Header, Segment, List} from 'semantic-ui-react';
import { Stage, Layer, Text } from 'react-konva';
import ColoredRect from './Animation/Animation';
import './style.css';

class Home extends Component {
  render() {
    return (
      <Segment style={{ padding: '7em 0em' }} vertical>
          <Grid container stackable verticalAlign='middle'>
            <Grid.Row>
                <Grid.Column width={4} />
                <Grid.Column width={8}>
                  <Header as='h3' style={{ fontSize: '2em' }}>Welcome</Header>
                  <p style={{ fontSize: '1.33em' }}>
                    Thanks for coming to my site. While you're here, feel free to click around and look at my projects and woodworking.
                  </p>
                <Header as='h3' style={{ fontSize: '2em' }}>Contact</Header>
                <Grid container stackable verticalAlign='middle'>
                  <Grid.Row>
                    <Grid.Column width={4} floated='left' className='links'>
                    <a href="http://github.com/tannergr"><i className="github icon"></i>GitHub</a></ Grid.Column>
                    <Grid.Column width={5} className='links'>
                    <a href="https://www.linkedin.com/in/tanner-graham/"><i className="linkedin icon"></i>LinkedIn</a></ Grid.Column>
                    <Grid.Column width={4} floated='right' className='links'>
                    <a href="mailto:tanner@tlgraham.com"><i className="mail icon"></i>Email</a></ Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
              <Grid.Column width={4} />


            </Grid.Row>

          </Grid>
        </Segment>
    );
  }

}

export default Home;



// WEBPACK FOOTER //
// ./src/Content/Pages/Home.js